import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

//datas gravadas pelo servidor (getdate no RDS) chegam em UTC sem offset - converter para horario local
export const formatDataHoraLocal = (value: string) => dayjs.utc(value).local().format("DD/MM/YYYY HH:mm");
